import { render } from "./VirementList.vue?vue&type=template&id=3444b4e4&scoped=true"
import script from "./VirementList.vue?vue&type=script&lang=js"
export * from "./VirementList.vue?vue&type=script&lang=js"

import "./VirementList.vue?vue&type=style&index=0&id=3444b4e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3444b4e4"]])

export default __exports__